type CalendarHeadIcon = 'MENST' | 'PREDICTED_MENST' | 'OVULATION' | 'PMS';
type CalendarBottomIcon = 'NOTE' | 'INTAKE';
type CalendarIcon = CalendarHeadIcon | CalendarBottomIcon;

export type CalendarIconInfo = { path: string, alt: string };

export const allCalendarIconInfo: { [key in CalendarIcon]: CalendarIconInfo } = {
  MENST: { path: '/calendar/menstruation.png', alt: 'menstruation date' },
  PREDICTED_MENST: { path: '/calendar/predicted_menstruation.png', alt: 'predicted menstruation date' },
  OVULATION: { path: '/calendar/ovulation.png', alt: 'ovulation date' },
  PMS: { path: '/calendar/pms.png', alt: 'pms date' },
  NOTE: { path: '/calendar/note.png', alt: 'date with note' },
  INTAKE: { path: '/calendar/intake.png', alt: 'intake date' },
};
